import { useEffect, useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useTypeahead, TypeaheadResults } from "./Typeahead";

// Cmd+K quick search over the Orders tab (openModalSearch). Typeahead → navigate.
export function QuickSearchModal({
  open,
  onClose,
  onRunQuery,
}: {
  open: boolean;
  onClose: () => void;
  onRunQuery: (q: string) => void;
}) {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const suggestions = useTypeahead(query);

  useEffect(() => {
    if (open) {
      setQuery("");
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="modal-overlay"
      style={{ display: "flex" }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="modal-search-container">
        <input
          type="text"
          placeholder="Search by customer name or twin check number..."
          autoComplete="off"
          autoFocus
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onRunQuery(query);
              onClose();
            }
          }}
        />
        <div className="typeahead-results" style={{ display: suggestions.length ? "block" : "none" }}>
          <TypeaheadResults
            suggestions={suggestions}
            onSelectCustomer={(id) => {
              onClose();
              navigate({ to: "/users/$customerId", params: { customerId: id } });
            }}
            onSelectValue={(v) => {
              onRunQuery(v);
              onClose();
            }}
            onViewOrder={(invoiceId) => {
              onClose();
              navigate({ to: "/orders/$invoiceId", params: { invoiceId } });
            }}
          />
        </div>
      </div>
    </div>
  );
}
